module.exports = __webpack_public_path__ + "assets/img/odium-mob.a40d8afb.png";